export default '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\
  <path d="M5.645 1.3L14.316 9.97L5.645 18.641" stroke="var(--color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\
</svg>'
